import { BuyCreditsModal } from "@/components/credits/BuyCreditsModal";
import { createFileRoute, redirect } from "@tanstack/react-router";
import z from "zod";
import { Route as IndexRoute } from "./index";

const historyStateSchema = z
  .object({
    neededCredits: z.number(),
  })
  .optional()
  .catch(undefined);

const parseHistoryState = (historyState: z.infer<typeof historyStateSchema>) =>
  historyStateSchema.parse(historyState);

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/adjust-week/$weekStart/buy-credits",
)({
  staticData: {
    crumb: "Tilkøb credits",
    meta: {
      title: "Tilkøb credits",
    },
  },
  beforeLoad: ({ location }) => {
    const historyState = parseHistoryState(
      location.state.routeStates?.[Route.id],
    );
    const indexHistoryState = location.state.routeStates?.[IndexRoute.id];

    if (!historyState || !indexHistoryState)
      throw redirect({
        from: Route.to,
        to: IndexRoute.to,
        replace: true,
      });

    return {
      parseHistoryState,
      useHistoryState: () => historyState,
      useIndexHistoryState: () => indexHistoryState,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { useHistoryState, useIndexHistoryState } = Route.useRouteContext();
  const navigate = Route.useNavigate();

  const historyState = useHistoryState();
  const indexHistoryState = useIndexHistoryState();

  const goBack = async (shouldContinue: boolean) => {
    await navigate({
      to: IndexRoute.to,
      state: {
        routeStates: {
          [IndexRoute.id]: {
            ...indexHistoryState,
            skipCreditCheck: shouldContinue,
            autoSubmit: shouldContinue,
          },
        },
      },
    });
  };

  return (
    <div className="flex flex-col">
      <BuyCreditsModal
        neededCredits={historyState.neededCredits}
        onClose={() => goBack(false)}
        onSuccess={() => goBack(true)}
        onSkip={() => goBack(true)}
      />
    </div>
  );
}
